import { render, staticRenderFns } from "./StoreRestDayManage.vue?vue&type=template&id=0f2fd059&scoped=true&"
import script from "./StoreRestDayManage.vue?vue&type=script&lang=js&"
export * from "./StoreRestDayManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fd059",
  null
  
)

export default component.exports